import styled, { css } from 'styled-components';
import { ReactComponent as PlayIcon } from 'assets/icons/play_circle_outline.svg';
import { variables } from 'components/theme';
import {
  itemMainBackgroundColor,
  itemAsideBackgroundColor,
  itemTextColor,
  itemTitleColor
} from 'utils/theme';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Header = styled.div`
  background: ${itemAsideBackgroundColor};
  padding: 7px 14px;

  h3 {
    color: ${itemTitleColor};
  }

  p,
  h5 {
    color: ${itemTextColor};
    ${variables.fonts.openSansSemiBold};
  }
`;

export const HeaderContent = styled.div`
  margin: 21px 0;
`;

export const MainContent = styled.div`
  ${({ embed }) =>
    !embed &&
    css`
      background: linear-gradient(
        to right,
        ${itemAsideBackgroundColor} 0%,
        ${itemAsideBackgroundColor} 50%,
        ${itemMainBackgroundColor} 50%,
        ${itemMainBackgroundColor} 100%
      );
    `}
`;

export const Aside = styled.aside`
  flex-grow: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: ${itemAsideBackgroundColor};
  border: 1px solid ${itemAsideBackgroundColor};
  padding: 105px 0;

  .container {
    width: 442px;
    margin-right: auto;
  }
`;

export const ShowCase = styled.div`
  display: flex;

  img {
    max-width: calc(25% - 21px);
    margin-right: 28px;
  }

  img:last-child {
    margin-right: 0px;
  }
`;

export const Main = styled.main`
  flex-grow: 2;
  padding: 98px 0 98px 63px;
  border-bottom: 1px solid rgba(112, 112, 112, 0.07);
  background: ${itemMainBackgroundColor};
  color: ${itemTextColor};

  .description a {
    color: ${variables.colors.blue1};
    text-decoration: none;
  }

  h1,
  h2 {
    color: ${itemTitleColor};
  }

  .subtotal {
    margin-bottom: 0;
  }

  .tickets,
  .description {
    margin: 21px 0;
  }
`;

export const About = styled.p`
  ${variables.fonts.openSansSemiBold}
  color: ${itemTextColor};
  line-height: 22px;
  margin-bottom: 84px;
`;

export const Details = styled.div`
  margin-bottom: 14px;

  a {
    color: ${variables.colors.blue1};
    text-decoration: none;
  }

  p {
    margin-bottom: 7px;
  }

  svg {
    vertical-align: middle;
    margin-right: 7px;
  }
`;

export const Currency = styled.div`
  display: flex;
  align-items: center;

  .css-wgxf7a-container {
    margin-bottom: 0;
  }

  .css-8n9vvk-placeholder {
    color: ${variables.colors.grey4};
    font-weight: 600;
  }
`;

export const SocialMedia = styled.div`
  display: flex;
  margin-bottom: 14px;
`;

export const Share = styled.div`
  margin-right: 28px;

  button {
    margin-right: 28px 28px 0px 28px;
    ${variables.fonts.openSansSemiBold};
    border: none;
    padding: 7px 14px;
    border-radius: 88px;
    background: ${itemAsideBackgroundColor};
    color: ${itemTextColor};
  }

  h5 {
    color: #222;
  }

  svg {
    fill: ${itemTextColor} !important;
  }

  @media (max-width: 768px) {
    button {
      border: 1px solid ${itemTextColor};
    }
  }
`;

export const Title = styled.div`
  h1 {
    line-height: 1.2;
  }
`;

export const Price = styled.div`
  h2 {
    line-height: 1.2;
  }
  margin: 21px 0 28px 0;

  h5 {
    text-transform: uppercase;
  }
`;

export const Table = styled.table`
  ${variables.fonts.openSansSemiBold};
  width: 100%;

  td,
  th {
    vertical-align: top;
    padding: 7px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.16);
  }
`;

export const Td = styled.td`
  color: ${itemTextColor} !important;
  width: 70px;
  text-align: center;

  span {
    color: ${itemTextColor};
  }

  svg {
    fill: ${itemTextColor};
    vertical-align: middle;
  }
`;

export const Th = styled.th`
  font-weight: 600;
  text-align: left;
`;

export const Tr = styled.tr`
  cursor: default;
  color: ${itemTextColor};

  :hover {
    background: ${itemAsideBackgroundColor};

    span {
      visibility: hidden;
    }

    .play {
      visibility: visible;
    }
  }
`;

export const PlayButton = styled.button`
  position: relative;
  border: none;
  background: transparent;
`;

export const Play = styled(PlayIcon)`
  width: 24px;
  height: 24px;
  visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
`;

export const FavoriteButton = styled.button`
  ${variables.fonts.openSansSemiBold};
  border: none;
  background: ${variables.colors.white};

  svg,
  span {
    vertical-align: middle;
    margin-right: 7px;
  }
`;

export const MoreAlbums = styled.div`
  padding: 35px 0;
  font-weight: 600;

  p {
    color: ${itemTitleColor};
    margin-bottom: 7px;
  }

  a {
    color: ${variables.colors.blue1};
    text-decoration: none;
  }
`;

export const AlbumShowcase = styled.div`
  display: flex;
  border-top: 1px solid rgba(112, 112, 112, 0.07);
  padding-top: 21px;

  & > div {
    max-width: calc(25% - 21px);
    margin-right: 28px;
  }

  & > div {
    margin-right: 0px;
  }
`;

export const CartButton = styled.button`
  border: none;
  background: none;
`;
